<template>
  <div v-if="current_profile && current_profile.type !== PROFILE_TYPES.CUSTOMER">
    <a
      v-if="current_profile && current_profile.type === PROFILE_TYPES.PARTNER"
      v-tooltip.bottom="$t('client.labels.helpcenter')"
      class="flex cursor-pointer flex-wrap items-center gap-2 rounded-md p-2 text-sm font-medium hover:bg-surface-100"
      :class="is_navbar_expanded ? 'mx-4' : 'justify-center'"
      :href="url"
      target="_blank"
    >
      <FontAwesomeIcon
        :icon="['far', 'circle-question']"
        size="lg"
      />
      <p v-if="is_navbar_expanded">
        {{ $t('client.labels.helpcenter') }}
      </p>
    </a>
    <div
      v-else
      v-tooltip.bottom="$t('client.labels.helpcenter')"
    >
      <a
        :href="url"
        target="_blank"
      >
        <FontAwesomeIcon
          class="has-text-white"
          :icon="['far', 'circle-question']"
        />
      </a>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { PROFILE_TYPES } from '@/app/data/model_constants';

const props = defineProps({
  is_navbar_expanded: { type: Boolean, default: false },
});

const store = useStore();

const current_profile = computed(() => store.getters.current_profile);

const collection_id = computed(() => (current_profile.value?.type === PROFILE_TYPES.PARTNER ? '10399347' : '10399348'));

const url = computed(() => {
  if (!current_profile.value) return '';
  return `https://help.ziggu.app/${current_profile.value.attributes.language}/collections/${collection_id.value}`;
});
</script>
